import request from 'checkout/utils/axios'

const removeCoupon = async code => {
  const response = await request
    .delete('/api/v1/cart/coupon', { couponCode: code })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export default removeCoupon
